/*=============================================== DemoContainer ===============================================*/

import styled from "styled-components/macro"
import { Aside, Main, Breakpoints } from "tsx-library-julseb"

const HEADER_HEIGHT = 64

export const StyledMain = styled(Main)`
    background-color: ${({ theme }) => theme.Danger100} !important;
    min-height: calc(100vh - ${HEADER_HEIGHT}px);
    background-color: transparent;

    @media ${Breakpoints.Tablet} {
        min-height: inherit;
    }
`

export const StyledAside = styled(Aside)`
    background-color: ${({ theme }) => theme.Danger100} !important;
    min-height: calc(100vh - ${HEADER_HEIGHT}px);
    background-color: transparent;

    @media ${Breakpoints.Tablet} {
        min-height: inherit;
    }
`
